var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressBookActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.533,
    height: 16.313,
    viewBox: "0 0 15.533 16.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Address_Book-act",
    "data-name": " Address Book-act",
    d: "M173.871,167.8a.534.534,0,0,1-.544-.544v-2.3a.534.534,0,0,1,.544-.544h1.341v-.979a.534.534,0,0,1,.544-.544H188.3a.534.534,0,0,1,.544.544v15.224a.545.545,0,0,1-.544.544H175.74a.545.545,0,0,1-.544-.544v-.979h-1.341a.534.534,0,0,1-.544-.544v-2.3a.534.534,0,0,1,.544-.544H175.2v-1.559h-1.341a.534.534,0,0,1-.544-.544V169.9a.534.534,0,0,1,.544-.544H175.2V167.8Zm9.787,2.646-.073.018-.054.054a2.887,2.887,0,0,1-1.486.689,2.731,2.731,0,0,1-1.5-.689l-.054-.054-.072-.018a1.68,1.68,0,0,0-1.794.816,4.387,4.387,0,0,0-.58,2.7,2.05,2.05,0,0,0,.272.961,1.412,1.412,0,0,0,1.2.725h5.02a1.419,1.419,0,0,0,1.214-.725,2.053,2.053,0,0,0,.272-.961,4.535,4.535,0,0,0-.58-2.719,1.658,1.658,0,0,0-1.776-.8Zm.054-2.32a1.685,1.685,0,1,0-1.685,1.685,1.685,1.685,0,0,0,1.685-1.685Z",
    transform: "translate(-173.311 -162.889)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBookActive);
export default __webpack_public_path__ + "static/media/address_book_active.be99a234f031fb21a331abad642d59c0.svg";
export { ForwardRef as ReactComponent };